import {
  Card,
  makeStyles,
  mergeClasses,
  shorthands,
  Skeleton,
  SkeletonItem,
  tokens,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  cardWrapper: {
    display: 'flex',
    flexGrow: 1,
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,

    '@media screen and (min-width: 768px)': {
      paddingLeft: tokens.spacingHorizontalXL,
      paddingRight: tokens.spacingHorizontalXL,
      paddingTop: tokens.spacingVerticalXL,
      paddingBottom: tokens.spacingVerticalXL,
    },
  },
  titleRow: {
    display: 'flex',
    marginBottom: tokens.spacingVerticalXXL,
  },
  title: {
    width: '20%',
  },
  descriptionRow: {
    rowGap: tokens.spacingVerticalXXL,
    marginBottom: tokens.spacingVerticalS,
    display: 'flex',
    alignItems: 'center',
  },
  description: {
    '@media screen and (min-width: 768px)': { maxWidth: '66%' },
    marginRight: tokens.spacingHorizontalXXL,
    width: '100%',
    rowGap: tokens.spacingVerticalXXL,
    display: 'flex',
    flexDirection: 'column',
  },
  descriptionItem: {},
  switchRow: {
    display: 'flex',
    alignItems: 'center',
    '@media screen and (min-width: 768px)': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  switchTitle: {
    marginRight: tokens.spacingHorizontalL,
    minWidth: '64px',
  },
  switchLabel: {
    minWidth: '24px',
  },
  switchs: {
    minWidth: '64px',
    height: '32px',
    marginLeft: tokens.spacingHorizontalS,
    marginRight: tokens.spacingHorizontalS,
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
  },
  switch: {
    width: '150px',
  },
});
export const GroovCardSkeleton = () => {
  const styles = useStyles();
  return (
    <Card className={styles.cardWrapper}>
      <Skeleton width={'100%'}>
        <div className={styles.titleRow}>
          <SkeletonItem shape={'rectangle'} size={32} className={styles.title} />
        </div>
        <div className={mergeClasses(styles.descriptionRow, 'bodyWrapper')}>
          <Skeleton className={styles.description}>
            <SkeletonItem shape={'rectangle'} size={32} />
            <SkeletonItem shape={'rectangle'} size={32} />
          </Skeleton>

          <SkeletonItem shape={'rectangle'} size={32} className={styles.switch} />
        </div>
      </Skeleton>
    </Card>
  );
};
